import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  addressLocationCheckAvailability,
  confirmCheckAvailability,
  emailAddressCheckAvailability,
  thanksCheckAvailability,
} from './check-availability-steps'

export const checkAvailabilityScenarioA: Scenario = {
  id: 'check-availability-a',
  initialStep: Steps.ADDRESS_LOCATION,
  type: ScenarioType.CHECK_AVAILABILITY,
  version: '1',
  milestones: [
    addressLocationCheckAvailability.id,
    emailAddressCheckAvailability.id,
    confirmCheckAvailability.id,
    thanksCheckAvailability.id,
  ],
  steps: [
    addressLocationCheckAvailability,
    emailAddressCheckAvailability,
    confirmCheckAvailability,
    thanksCheckAvailability,
  ],
}
